/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_ListingInputs */

const en_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Listing`)
};

const es_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver anuncio`)
};

const fr_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'annonce`)
};

const de_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat ansehen`)
};

const ja_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を見る`)
};

const zh_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看商品`)
};

const ar_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الإعلان`)
};

const id_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Listing`)
};

const it_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi Annuncio`)
};

const ru_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть объявление`)
};

const pt_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Anúncio`)
};

const ko_view_listing = /** @type {(inputs: View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 보기`)
};

/**
* | output |
* | --- |
* | "View Listing" |
*
* @param {View_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_listing = /** @type {((inputs?: View_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_listing(inputs)
	if (locale === "es") return es_view_listing(inputs)
	if (locale === "fr") return fr_view_listing(inputs)
	if (locale === "de") return de_view_listing(inputs)
	if (locale === "ja") return ja_view_listing(inputs)
	if (locale === "zh") return zh_view_listing(inputs)
	if (locale === "ar") return ar_view_listing(inputs)
	if (locale === "id") return id_view_listing(inputs)
	if (locale === "it") return it_view_listing(inputs)
	if (locale === "ru") return ru_view_listing(inputs)
	if (locale === "pt") return pt_view_listing(inputs)
	return ko_view_listing(inputs)
});